import {getClassInstanceElementId} from "../scrollToClassInstance";

/**
 * Build the login href for a guest Add to Cart click.
 * Redirects back to the current course page anchored on the chosen class.
 */
export function buildAddToCartLoginHref(
	loginPath: string,
	pathname: string,
	query: string,
	classInstanceId: string
): string {
	const redirectPath = `${pathname}${query ? `?${query}` : ""}#${getClassInstanceElementId(classInstanceId)}`;
	return `${loginPath}?redirect=${encodeURIComponent(redirectPath)}`;
}
